<div class="activation-required-dialog">
  <div class="ard-header">
    <div class="ard-header__glow" aria-hidden="true"></div>
    <div class="ard-header__badge">
      <mat-icon>lock_open</mat-icon>
    </div>
    <span class="ard-header__eyebrow">Módulo exclusivo</span>
    <h2 class="ard-header__title">Libera el poder de Reservas PRO</h2>
    <p class="ard-header__subtitle">Gestiona reservas, calendario y confirmaciones desde un único lugar</p>
  </div>

  <div class="ard-body">
    <div class="ard-trial">
      <span class="ard-trial__ribbon">Gratis</span>
      <div class="ard-trial__icon"><mat-icon>card_giftcard</mat-icon></div>
      <div class="ard-trial__text">
        <h3>Prueba gratis hasta diciembre</h3>
        <p>Activa hoy y disfruta de acceso completo sin coste hasta el <strong>31 de diciembre de 2026</strong>.</p>
      </div>
    </div>

    <div class="ard-features">
      <span class="ard-features__title">Te abrimos acceso a</span>
      <div class="ard-features__grid">
        <div class="ard-feature">
          <div class="ard-feature__icon"><mat-icon>assignment</mat-icon></div>
          <span>Gestión completa de reservas</span>
        </div>
        <div class="ard-feature">
          <div class="ard-feature__icon"><mat-icon>date_range</mat-icon></div>
          <span>Calendario integrado</span>
        </div>
        <div class="ard-feature">
          <div class="ard-feature__icon"><mat-icon>check_circle</mat-icon></div>
          <span>Confirmación automática</span>
        </div>
        <div class="ard-feature">
          <div class="ard-feature__icon"><mat-icon>notifications</mat-icon></div>
          <span>Notificaciones en tiempo real</span>
        </div>
      </div>
    </div>
  </div>

  <div class="ard-actions">
    <button mat-button (click)="onClose()" class="ard-btn-cancel">Ahora no</button>
    <button mat-raised-button (click)="onActivate()" class="ard-btn-activate">
      <mat-icon>flash_on</mat-icon>
      <span>¡Activar ahora!</span>
    </button>
  </div>
</div>
